<script lang="ts">
/*
Basic button class- for doing stuff 

Have some basic button types:
* Delete (close icon)
* Edit (edit icon)
* Submit (arrow_forward)

*/
import { defineComponent } from 'vue'
import Loading_IconVue from './Loading_Icon.vue';


export default defineComponent({

components: {Loading_IconVue },

async mounted()
{
    this.classes = [this.type, this.class];

    if(this.hover_effect_scale)
        this.classes.push ("hover_effect_scale");
    if(this.hover_effect_dim)
        this.classes.push ("hover_effect_dim");

    if(this.type=="no")
    {
        this.text_d="";
        this.icon_self="close";
    }
    else if(this.type=="yes")
    {
        this.text_d="";
        this.icon_self="arrow_forward";
    }
    else if(this.type=="delete")
    {
        this.text_d="";
        this.icon_self="delete";
    }
    else if(this.type=="back")
    {
        this.text_d="";
        this.icon_self="arrow_back";
    }
    else if(this.type=="add")
    {
        this.icon_self="add_circle";
    }
    else if(this.type=="check")
    {
        this.icon_self="check";
        // this.classes.push("check");
        console.log("Button: type check, this checked: ",this.checked);
        if(this.checked)
            this.Select(this.checked);
    }
    // this.text_d=this.text.replace(" ", "<br/>");
    if(this.wrap_txt)
        this.text_d = this.text.replace(" ", "<br/>");
    else
        this.text_d=this.text;
    // this.text_d=this.text;

    if(this.icon)
        this.icon_self=this.icon;
    // console.log("Button vue, this text: "+this.text);
    
},
props:
{
    
    text:{type:String, default:""},
    icon:{type:String, default:""},
    type:{type:String, default:"default"},
    checked:{type:Boolean, default:false}, //for check mark buttons in

    icon_dir:{type:String, default:"column"}, //for if the icon should be to the left, or on top of the text
    wrap_txt:{type:Boolean, default:false}, //for inserting a breakline for buttons for spaces

    fontsize:{type:String, default:"20px"},
    fontsize_icon:{type:String, default:"32px"},
    fontweight: {type:String, default:"bold"},
    callback:{type:Function, default:()=>{console.log("button clicked!")}},
    callback_enter:{type:Function, default:()=>{console.log("enter hit!")}},
    extra_info:{},//for sending extra info- like the id of the thing that got clicked
    
    color_bg:{type:String},
    color_bg2:{type:String},
    color_txt:{type:String},

    hover_effect_scale:{type:Boolean, default:true},
    hover_effect_dim:{type:Boolean, default:false},

    // focus_css:{type:String, default:"border:1px solid white;" },

    border_radius:{type:String, default:"10px"},

    class:{type:String, default:""},/*Mainly for adding in the category class */
    // style:{type:String, default:""}, //for adding extra styles

    hold_for_callback:{type:Boolean, default:false},
    hold_callback:{type:Function, default:()=>{console.log("hold fired!")}},
    hold_delay:{type:Number, default:500}, //how long to wait for loading to popup
    hold_req_time:{type:Number, default:500}, //how long for loading popup to show before counting as a held/ callback will bne fired when released
    padding:{type:String, default:"10px 10px"},
    margin:{type:String, default:"10px 10px"},
},
data() {
        return {
        // icon:{ type:String, default:"home"},
        text_d:"",
        icon_self:"",
        classes:[""],

        //for enabling/ disabling outlines
        outline1_size:"2px",
        outline1_color:"black",
        outline2_size:"2px",
        outline2_color:"white",
        
        selected:false, //for checkmark buttons

        pointer_down:false,//if mouse_down
        pointer_over:false,//if mouse over button
        held_start:0,
        held_counter:0,
        held_triggered:false,//for when they've held long enough to trigger held callback to be fired
        held_interval:undefined, //for having the intervbal run while the mouse is held down, to check if it is still held down...
        held_delay_passed:false, //for when they've held over the delay, and can play animation
        
        //for held mouse pos
        held_x:0,
        held_y:0,
        loading_size:40,

        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {
    cssProps() {
      return {

        '--font-size': this.fontsize,
        '--font-size-icon': this.fontsize_icon,
        '--bg-color':this.GetBGColor(),
        '--bg-color2':this.GetBGColor2(),
        '--font-color': this.GetFontColor(),
        '--fontweight': this.fontweight,

        '--icon-dir': this.icon_dir,

        '--padding': this.padding,
        '--margin': this.margin,

        // '--focus_css':this.focus_css,
        
      }
    },
    OutlineCSSProps() 
    {
      return {
        '--outline1_size': this.outline1_size,
        '--outline1_color':this.outline1_color,
        '--outline2_size': this.outline2_size,
        '--outline2_color':this.outline2_color,

        '--border-radius':this.border_radius,
      }
    },
    LoadingProps() {
      return {

        '--x': (this.held_x-(this.loading_size/2))+"px",
        '--y': (this.held_y-(this.loading_size/2))+"px",
      }
    },

  },
  methods:
  {
    /*
    to add or remove an outline
    */
    SetOutline(outline1_size:number, outline1_color:string, outline2_size:number, outline2_color:string)
    {
        this.outline1_size=outline1_size+"px";
        this.outline1_color=outline1_color;

        this.outline2_size=outline2_size+"pt";
        this.outline2_color=outline2_color;
    },
    ShowOutline()
    {
        // console.log(this.$refs.bg);
        (this.$refs.bg as any).classList.add("selected_btn");
    },
    HideOutline()
    {
        (this.$refs.bg as any).classList.remove("selected_btn");
    },
    GetMainElement()
    {
        return this.$refs.main_element;
    },

    ButtonClicked(event:any)
    {
        if(this.type=="check")
            this.Select(!this.selected);

        let extra_info = this.extra_info;
        // console.log("button clicked function!!!", event, "sending back extra info: ", this.extra_info);
        //lets also send back what button was clicked
        if(!extra_info)
            extra_info = {};
        (extra_info as any).btn=this;
        this.callback(extra_info);
    },
    EnterClicked(event:any)
    {
        console.log("enter clicked!");
        if(this.type=="check")
            this.Select(!this.selected);

        let extra_info = this.extra_info;
        // console.log("button clicked function!!!", event, "sending back extra info: ", this.extra_info);
        //lets also send back what button was clicked
        if(!extra_info)
            extra_info = {};
        (extra_info as any).btn=this;
        this.callback_enter(extra_info);
    },
    GetBGColor()
    {
        let str="";

        if(this.color_bg)
            str = this.color_bg;
        else if(this.type=="no"||this.type=="back")
            str="red"
        else if(this.type=="yes")
            str="green"
        else
            str = "blue";
        // console.log("GetBG color, BG color: "+str);

        return str;
    },
    GetBGColor2()
    {
        let str=this.GetBGColor();

        //else we'll just darken it a bit

        if(this.color_bg2)
            str = this.color_bg2;
        else
        {
            str="color-mix(in hsl,var(--bg-color),hsl("+(Math.random()*360)+", 50%, 0%) 10%)";
        }
        return str;
    },
    GetFontColor()
    {
        let str="";

        if(this.color_txt)
            str = this.color_txt;
        else
            str = "white";

        // console.log("for text", this.text, "font color: ",str)

        return str;
    },
    /* GetBorderRadius()
    {
        let str="10px";

        if(this.border_radius)
            str = this.border_radius;

        return str;
    }, */
    //for checkmark buttons:
    Select(select:boolean)
    {
        this.selected=select;
        if(select)
            (this.$refs.icon as HTMLElement).classList.add("checked");
        else
            (this.$refs.icon as HTMLElement).classList.remove("checked");
    },
    ShowHeld()
    {
        return this.hold_for_callback && this.held_counter > this.hold_delay;
    },

    //apparently pointer down only fires once- so need to check regularly at our own interval
    PointerDown(event:MouseEvent)
    {
        var rect = (event.target as any).getBoundingClientRect();
        this.held_x = event.pageX - rect.left; //x position within the element. //clientX doesn't work when scrolling on mobile- pageX instead
        this.held_y = event.pageY - rect.top;  //y position within the element.
        console.log("x, y: ",this.held_x, this.held_y);
        // (this.$refs.loading as HTMLElement).style.top=this.held_x+"px";
        // console.log("this loading: ", this.$refs.loading);

        this.PointerUp();//hack- think "this" in JS is being random functions instead of this class, so doesn't get reset on pointer  up always...
        this.pointer_down=true;
        

        
        // console.log("pointer down held counter:", this.held_counter, "hold delay: ", this.hold_delay, "held_start", this.held_start, "this: ",this)
        // if(this.held_start==0)
        window.requestAnimationFrame(this.PointerDownLoop);
        // this.held_start= Date.now();
        
        // this.held_counter=Date.now()-this.held_start;
        // console.log("held counter: ", this.held_counter, "this.held_start", this.held_start)

    },
    //if pointer moves too much/ no longer down on us, need to cancel doing the right click
    async PointerMove(event:MouseEvent)
    {
    },
    async PointerDownLoop(time_stamp:number)
    {
        if(!this.hold_for_callback)//only for holding buttons
            return;

        if(this.held_start==0)
            this.held_start=time_stamp;

        this.held_counter=time_stamp-this.held_start;

        if(!this.held_delay_passed && this.held_counter>this.hold_delay )
        {
            console.log("hold delay triggered!");

            let count=0;
            while(!this.$refs.circle_conf&&count<100)
            {
                await this.$nextTick();
                //need to delay to next tick
                if(this.$refs.circle_conf)
                {
                    (this.$refs.circle_conf as HTMLElement).classList.add("circle_anim");
                    (this.$refs.check_held as HTMLElement).classList.add("check_anim");
                }
                count++;
            }
            
            this.held_delay_passed=true;
        }
        if(this.held_counter>this.hold_delay +this.hold_req_time)
        {
            console.log("final trigger fired!");
            this.pointer_down=false;
        }

        

        // if(this.held_counter > this.hold_delay)
        //     console.log("counter greater than delay! counter: ", this.held_counter , "delay: ", this.hold_delay)

        if(this.pointer_down)
            window.requestAnimationFrame(this.PointerDownLoop);
    },
    PointerUp()
    {
        


        console.log("pointer up! this.hold_for_callback: ", this.hold_for_callback)
        // console.trace();
        if(!this.hold_for_callback)//only for holding buttons
            return;
            

        if(this.held_counter>this.hold_delay +this.hold_req_time)
            this.HoldUpTriggered();

        if(this.$refs.circle_conf)
        {
            (this.$refs.circle_conf as HTMLElement).classList.remove("circle_anim");
            (this.$refs.check_held as HTMLElement).classList.remove("check_anim");
        }


        this.held_delay_passed=false;
        this.pointer_down=false;
        this.held_counter=0;
        this.held_start=0;
        console.log("pointer up held counter:", this.held_counter, "hold delay: ", this.hold_delay, "held start: ", this.held_start, "this: ",this)
    },
    // for when they've held down long enough to trigger the callback
    HoldUpTriggered()
    {
        console.log("hold up triggered");
        this.hold_callback(this.extra_info);
    },
    //if the pointer leaves the button, add event listener for document up instead
    PointerLeave()
    {
        // if(!this.hold_for_callback)//only for holding buttons
        //     return;

        /* this.pointer_over=false;
        //now add a listener for the document for mouse up if mouse is down
        if(this.pointer_down)
        {
            console.log("Button: pointer leave");
            let pointer_up = ()=>{ this.PointerUp();document.removeEventListener("pointerup", pointer_up);};
            let event_listener = document.addEventListener("pointerup", pointer_up);
        } */
        if(this.pointer_down)
        {
            // console.log("pointer leave!");
            this.PointerUp();
        }
    },
    PointerEnter()
    {
        if(!this.hold_for_callback)//only for holding buttons
            return;

        // console.log("pointer entered");
        this.pointer_over=true;
    },
    Focus()
    {
        console.log("focusing on button");

        (this.$refs.main_element as HTMLInputElement).focus();
    },

  },
  watch: 
    {
        text:function(text_in:string) 
        {
            // console.log("Watch on button text called!", text_in);
            if(this.wrap_txt)
                this.text_d = text_in.replace(" ", "<br/>");
            else
                this.text_d=text_in;
            // this.force_vue_update++;
        },
        icon:function(icon_in:string) 
        {
            this.icon_self=icon_in;
        },
        checked:function(checked_in:boolean) 
        {
            console.log("Button: watch Checked changed!", checked_in );
            this.Select(checked_in);
        },
        
    },
});
</script>

<template  >
    <!-- Adding a  @click.stop to stop bubbling the click eevent up the the parents- so otherwise on EntryEl, it listens for a click inside it, to open- but if the click is on the close button, it re-opens
    So want to get clicks inside it- but not the entry editable portion-->
    
    <button 
    ref="main_element"
    :class="classes" 
    :style="cssProps" 
    @click.stop="(event)=>{ButtonClicked(event)}"
    @keyup.enter.stop ="(event)=>{EnterClicked(event)}"

    @pointerdown="PointerDown"
    @pointerup="PointerUp"
    @pointerleave="PointerLeave"
    @pointerenter="PointerEnter"
    @pointermove="PointerMove"
    @pointercancel="PointerUp" 
    >
        
        <span :style="OutlineCSSProps" class="bg no_events" ref="bg"></span>

        <div style="display: flex; align-items: center;  gap:2px; flex-direction: var(--icon-dir);">
            <span v-if="icon_self||type=='check'" class="material-symbols-outlined no_events icon" ref="icon">{{icon_self}}</span>
            <span v-if="text_d" class="txt no_events" v-html="text_d"></span>
            
        </div>

        <div class="loading" v-if="ShowHeld()"  :style="LoadingProps">
            <Loading_IconVue :size="loading_size"/>
            
            <p class="circle_conf" ref="circle_conf"></p>
            <span class="material-symbols-outlined no_events check_held" ref="check_held"  >check</span>

        </div>
    </button>
</template>

<style scoped>
button
{
    cursor: pointer;
    border:none;
    
    padding:var(--padding);

    
    transition: all .1s;
    margin:var(--margin);

    /* overriding styles if sent */
    
    color:var(--font-color);
    position: relative;
    background: none;

    flex: 1 1 auto;
    /* max-width: 48%;  */

}
button:focus
{
    outline:0 !important;
}
button:focus .bg, .selected_btn /* have to add this, or if we loose focus, it looks crappy/ black and white default outlines again*/
{
    border-color: #66afe9 !important;
    outline: 0 !important;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(var(--color1), 0.6) !important;


    /* border:0 !important;
    box-shadow: none !important; */
}
/* button:focus-visible
{

    outline:0 !important;
    border:0 !important;
    box-shadow: none !important;
} */
.bg/* bg for having just it darken- not the actual icon and stuff too*/
{
    /* background-color: var(--bg-color); */
    background: linear-gradient(var(--bg-color), var(--bg-color2));

    /* does work */
    /* --color-dark:  color-mix(in srgb,var(--bg-color),#000 80%); */
    --color-dark:  color-mix(in hsl,var(--bg-color),hsl(0, 0%, 100%) 20%);

    /* doesn't work */
    /* --color-dark:  hsl(var(--color),calc(50% - 10%)); */

    /* --color-dark: hsl(
    hue(var(--bg-color)),
    saturation(var(--bg-color)),
    calc(lightness(var(--bg-color)) * 0.3) );*/
    /* --color-dark:mix(#000, $myColor, 30%); */
  
    border: 3px solid var(--color-dark);
    /* border: 1px solid color-mix(in srgb,var(--bg-color),#000 30%); */
    
    width: 100%;
    height:100%;
    display:block;
    position: absolute;
    top:0;
    left:0;
    border-radius: var(--border-radius);
    z-index:-1;
}
.hover_effect_scale
{
    filter: brightness(.95);
}
.hover_effect_scale:hover
{
    transform: scale(.98);
    /* width: calc(100%); */
}
.hover_effect_scale:active
{

    transform: scale(0.95) translate(0px, 2px);
}
.hover_effect_scale:hover .bg
{
    filter: brightness(1);
}
.hover_effect_scale:active .bg
{
    filter: brightness(.8);
}

.hover_effect_dim:hover .bg
{
    filter: brightness(.8);
}
.hover_effect_dim:active .bg
{
    filter: brightness(.5);
}


.no
{
    /* background-color: var(--red); */
    /* color:white; */
    /* padding:5px 5px;  */
}
.yes
{
    /* background-color: var(--green); */
    /* color:white; */
    /* padding:5px 5px;  */
}
span 
{
    font-size:var(--font-size);
    font-weight: var(--fontweight);

    /* line-height:1.5em; */
}

@media only screen and (max-device-width: 768px)
{
    span 
    {
        /* font-size:20px; */
    }
}
@media only screen and (max-device-width: 465px)
{
    span 
    {
        /* font-size:16px; */
    }
}



/* for categories */
.icon_w_txt
{
    padding: 20px;
    /* background-color: #777; */
    /* color:var(--txt-color); */
    
    text-align: center;
    background-color:var(--bg-color);
    transition: all 100ms;
    transform: scale(1);
    margin:10px;
    user-select: none;
    cursor: pointer;

    position: relative;
    
    border-radius: 10px;
    /* aspect-ratio: 1; */
    /* width:100px;
    height:100px; */
    min-width:.5in;
    min-height:.5in;
    /* max-width:1in; */
    /* height:1in */
    /* height:2in;
    width:3in; */

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;

}
.gradient
{
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, .2));
    position:absolute;
    width:90%;
    height:90%;
    top:5%;
    left:5%;
    border-radius: 10px;
}
.highlight
{
    background: linear-gradient(rgba(255, 255, 255, .3), rgba(255, 255, 255, 0));
    position:absolute;
    width:90%;
    height:90%;
    top:5%;
    left:5%;
    border-radius: 10px;
    height:20%;
}

.category:hover
{
    transform: scale(1.2);
}
.icon_w_txt .txt
{
    display: block;
    font-size:12px;
}

.icon
{
    font-size:var(--font-size-icon);
}

.icon_w_txt .material-icons-outlined, .icon_w_txt .material-symbols-outlined
{
    -moz-osx-font-smoothing: grayscale;

  font-variation-settings:
  'FILL' 0,
  'wght' 300,
  'GRAD' 0,
  'opsz' 24;

  font-size:var(--font-size-icon);
}
/* For adding an outline to a button */
.selected_btn
{
    border:var(--outline1_size) solid var(--outline1_color);
    box-shadow: 0 0 var(--outline1_size) var(--outline2_size) var(--outline2_color);
}
.check .material-symbols-outlined
{
    background-color:white;
    color:white;
    
    /* margin-right:10px; */
    float: left;
    margin-top:2px;
}
/* for when the checkbox is checked*/
.check .checked
{
    color:black;
}
.loading
{
    position: absolute;
    left:var(--x);
    top:var(--y);

}
/* for not having it do pointer events on children- or loading icon comes offset by the childen, not the parent
could probably find other ways to do it/ only offset by parent with reference */
.no_events
{
    pointer-events: none;
}
.circle_conf
{
    background-color:rgb(131,58,180); position: absolute; top:0;left:0;right:0;bottom:0; border-radius: 100%; background-image: radial-gradient(circle, rgb(7, 29, 113) 21%, rgb(27, 72, 15) 57%, rgb(166, 16, 16) 80%);border: 1px solid white;
    /* transform:scale(0) */
    transform: scale(0);
    

}
.circle_anim
{
    animation: circle_growth 0.5s cubic-bezier(0.5, 0, 0.5, 1) 1;
    animation-fill-mode: forwards;
}
@keyframes circle_growth {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(120%);
  }
  100% {
    transform: scale(100%);
  }
}
.check_anim
{
    animation: check_growth 0.1s cubic-bezier(0.5, 0, 0.5, 1) 1;
    animation-fill-mode: forwards;
}
@keyframes check_growth {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  80% {
    transform: translate(-50%, -50%) scale(120%);
  }
  100% {
    transform: translate(-50%, -50%) scale(100%);
  }
}
.check_held
{
    position:absolute; 
    left:50%;
    top:50%;
    transform: translate(-50%, -50%) scale(0); 
    font-size:20px;
    animation-delay: 500ms;
}


</style>